/**
 * Given an object, will return a query params string
 * @param obj Object
 * @return Query params
 * @example
 * getURLQueryFromObject({foo: 'bar', moo: 'iar'}): "?foo=bar&moo=iar"
 */
export const getURLQueryFromObject = (
	obj: Record<string, number | string> = {},
) => {
	return obj
		? Object.entries(obj).reduce(
				(accum, [key, value], index) =>
					accum +
					((!index ? `?` : `&`) + `${key}=${encodeURIComponent(value)}`),
				'',
		  )
		: '';
};

export default getURLQueryFromObject;
